'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _searchbar = require('./searchbar');

var _searchbar2 = _interopRequireDefault(_searchbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _searchbar2.default;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-weui/build/packages/components/searchbar/index.js
// module id = 2270
// module chunks = 0